import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Title/title';
export var TitleSizes;

(function (TitleSizes) {
  TitleSizes["md"] = "md";
  TitleSizes["lg"] = "lg";
  TitleSizes["xl"] = "xl";
  TitleSizes["2xl"] = "2xl";
  TitleSizes["3xl"] = "3xl";
  TitleSizes["4xl"] = "4xl";
})(TitleSizes || (TitleSizes = {}));

var headingLevelSizeMap;

(function (headingLevelSizeMap) {
  headingLevelSizeMap["h1"] = "2xl";
  headingLevelSizeMap["h2"] = "xl";
  headingLevelSizeMap["h3"] = "lg";
  headingLevelSizeMap["h4"] = "md";
  headingLevelSizeMap["h5"] = "md";
  headingLevelSizeMap["h6"] = "md";
})(headingLevelSizeMap || (headingLevelSizeMap = {}));

export var Title = function Title(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? '' : _a$children,
      HeadingLevel = _a.headingLevel,
      _a$size = _a.size,
      size = _a$size === void 0 ? headingLevelSizeMap[HeadingLevel] : _a$size,
      props = __rest(_a, ["className", "children", "headingLevel", "size"]);

  return React.createElement(HeadingLevel, Object.assign({}, props, {
    className: css(styles.title, size && styles.modifiers[size], className)
  }), children);
};